import styled from "styled-components";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
export const StyledActionMenuSeparatorLi = styled.div.withConfig({ displayName: "StyledActionMenuSeparatorLi_APC-7311-productShell", componentId: "sc-objjc" })({
    padding: `${apolloSpaceInsetHalfX} 0`,
});
export const StyledActionMenuSeparatorLine = styled.div.withConfig({ displayName: "StyledActionMenuSeparatorLine_APC-7311-productShell", componentId: "sc-1kx7mlv" })(({ theme }) => ({
    height: "1px",
    backgroundColor: theme.colors.apolloColorStrokePopoverSeparator,
}));
//# sourceMappingURL=ActionMenuSeparator.style.js.map